import { useState } from 'react';
import { useProductSelection } from '../../hook/useProductSelection';
import { formatViewNumber } from '../../utils/utils';
import Button from '../button/button.component';
import SelectItem from '../modal-item/flor-item/select-item.component';
import ModalItem from '../modal-item/modal-item';
import './product-card.styles.scss';

const ProductCard = ({ product }) => {
  const { name, lowerPrice, imageUrl, price } = product;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { totalPrice, selectPrice, addProductToCart } =
    useProductSelection(product);

  return (
    <div className="product-card-container">
      {/* Le cadre entier ouvre la fiche : au survol l'intitulé n'est qu'un rappel,
          et il reste masqué sur mobile où il n'y a pas de survol. C'est le cadre
          qui porte l'interaction, donc l'intitulé est un simple <span> : un
          <button> dans un <button> serait du HTML invalide. */}
      <button
        type="button"
        className="product-card-media"
        onClick={handleOpen}
        aria-label={`Voir le produit ${name}`}
      >
        <img src={imageUrl} alt={name} />

        <span className="button-container product-card-cta">
          Voir le produit
        </span>
      </button>

      <div className="product-card-footer">
        <span className="product-card-name">{name}</span>
        <span className="product-card-price">
          {lowerPrice || `${formatViewNumber(price)} €`}
        </span>
      </div>

      {/* Le palier se choisit sans ouvrir la fiche, qui reste là pour la
          description et les taux. */}
      <SelectItem product={product} value={totalPrice} onSelect={selectPrice} />

      <Button
        className="product-card-add"
        type="button"
        disabled={!totalPrice}
        onClick={addProductToCart}
      >
        Ajouter
      </Button>

      <ModalItem handleClose={handleClose} open={open} product={product} />
    </div>
  );
};

export default ProductCard;
